import React, {useState} from "react";
import {Typography} from "@mui/material";
import ETLJobTableApplet from "../eoec/applet/impl/ETLJob/ETLJobTableApplet";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import ETLJobExecutionTableApplet from "../eoec/applet/impl/ETLJob/ETLJobExecutionTableApplet";
import ETLJobExecutionDetailApplet from "../eoec/applet/impl/ETLJob/ETLJobExecutionDetailApplet";
import useAppContext from "../util/AppContext";


export default function Jobs() {
    const [etlJobEnterpriseObject] = useState(enterpriseObjectClassFactory("ETLJob") as EnterpriseObject);
    const appContext = useAppContext();

    function renderJobs() {
        return (
           <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px", }}>
               <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                    <ETLJobTableApplet enterpriseComponent={etlJobEnterpriseObject?.getEnterpriseComponent("ETLJob")}/>
                </div>
               <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                    <ETLJobExecutionTableApplet enterpriseComponent={etlJobEnterpriseObject?.getEnterpriseComponent("ETLJobExecution")}/>
                </div>
               <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                    <ETLJobExecutionDetailApplet enterpriseComponent={etlJobEnterpriseObject?.getEnterpriseComponent("ETLJobExecution")}/>
                </div>
           </div>
        )
    }

    return (
        <div style={{display: "flex", flexDirection: "column", width: appContext?.sessionContext.getShowGlobalMenu() ? "calc(100% - 250px)" : "100%"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Jobs</Typography>
                </div>
            </div>
            {renderJobs()}
        </div>
    );
}